import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material/tabs';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';
import { ViewColumnComponent } from '../../../../../view-column.component';
import { SubSink } from 'subsink2';
import { BranchSettingsFacade } from '../../../facades/branch-settings.facade';
import { BranchSettingsSelectors } from '../../../branch-settings-controller/selectors';
import { BranchSettingsActions} from '../../../branch-settings-controller/actions';
import { BranchSettingsStates } from '../../../branch-settings-controller/states';
interface LocalState {
  deactivateAdd: boolean;
  deactivateReturn: boolean;
  selectedIndex: number;
  deleteConfirmation: boolean;
}
export interface AddAttachment {
  id?: string;
  file: File;
  fileSRC: string | ArrayBuffer;
  fileAttributes: {
      fileName: string
      size: string
  }
}
@Component({
  selector: 'app-branch-printable-image-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [ComponentStore]
})

export class BranchPrintableImageAddComponent extends ViewColumnComponent {

  protected subs = new SubSink();

  protected compName = 'Add Branch Printable Image';
  protected index = 8;
  protected localState: LocalState;
  readonly localState$ = this.viewColFacade.selectLocalState(this.index);

  byteSize = ['Bytes', 'KB', 'MB'];
  attachment: AddAttachment;
  branchGuid;
  form: FormGroup;
  @ViewChild(MatTabGroup) matTab: MatTabGroup;

  constructor(
    private branchSettingsStore: Store<BranchSettingsStates>,
    protected viewColFacade: BranchSettingsFacade,
    protected readonly componentStore: ComponentStore<LocalState>
    ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.branchSettingsStore.select(BranchSettingsSelectors.selectBranch).subscribe(b=>{
      this.branchGuid = b.guid;
    })
    this.subs.sink = this.localState$.subscribe( a => {
      this.localState = a;
      this.componentStore.setState(a);
    });
    this.form = new FormGroup({
      imageCode: new FormControl(),
      imageName: new FormControl()
    })

  }

  onChange(e: FileList) {
    let attachment: AddAttachment;
    Object.values(e).forEach(file => {
      let size = file.size, sizeIncrement = 0;
      while (size >= 1024) {
        size /= 1024;
        sizeIncrement++;
      }
      const fileReader = new FileReader();

      fileReader.readAsDataURL(file);
      fileReader.addEventListener('loadend', (a) => {
        attachment = {
          file,
          fileSRC: file.type.includes('image') ? a.target.result : 'icon',
          fileAttributes: {
            fileName: file.name,
            size: `${sizeIncrement > 0 ? size.toFixed(2) : size} ${this.byteSize[sizeIncrement]}`
          }
        }
        this.attachment = attachment;

      });
    });
  }

  disableAdd() {
    let result = false;
    if(!this.attachment){
      result = true;
    }
    if(this.form.invalid){
      result = true;
    }
    if(this.attachment &&
      (this.attachment.fileAttributes.fileName.endsWith('.jpg')
    || this.attachment.fileAttributes.fileName.endsWith('.png')
    || this.attachment.fileAttributes.fileName.endsWith('.jpeg')
    || this.attachment.fileAttributes.fileName.endsWith('.gif')
    )){
      result = false;
    }else{
      result = true;
    }

    return result;
  }

  onDeleteFile() {
    this.attachment = null
  }

  onReturn(){
    this.viewColFacade.onPrev(1);
  }

  onAdd() {
    const data = {
      "attachment": this.attachment,
      "imageCode": this.form.value.imageCode,
      "imageName": this.form.value.imageName
    }
    console.log('data',data);
    this.branchSettingsStore.dispatch(BranchSettingsActions.addPrintableImageInit({ data }));
  }

}
